export const getAuthorsDisplay = (metadata) => {
  const holders = metadata?.copyright_holders;
  if (!holders) return null;

  const editors = holders.editors || [];
  const authors = holders.authors || [];
  const contributors = holders.contributors || [];

  const allPeople = [...editors, ...authors, ...contributors];
  if (allPeople.length === 0) return null;

  const firstPerson = allPeople[0];
  const name = `${firstPerson.first_name || firstPerson.forename || ''} ${firstPerson.last_name || firstPerson.surname || ''}`.trim();
  
  if (allPeople.length === 1) {
    return name;
  }
  return `${name} et al.`;
};

export const getCopyrightHoldersCount = (metadata) => {
  const holders = metadata?.copyright_holders;
  if (!holders) return 0;

  const editors = holders.editors || [];
  const authors = holders.authors || [];
  const contributors = holders.contributors || [];

  return editors.length + authors.length + contributors.length;
};

export const getLicenseInfo = (metadata) => {
  const openAccess = metadata?.open_access;
  if (!openAccess) return { isOpen: false, label: null };

  if (openAccess.open_access_yn === 'Y') {
    return { 
      isOpen: true, 
      label: openAccess.cc_license_term || openAccess.cc_license_type || 'Open Access' 
    };
  }
  return { isOpen: false, label: 'Closed Access' };
};
